import { render } from "./BenefitShowComponent.vue?vue&type=template&id=4d785212"
import script from "./BenefitShowComponent.vue?vue&type=script&lang=js"
export * from "./BenefitShowComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/settings/Benefit/BenefitShowComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4d785212"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4d785212', __exports__)) {
    api.reload('4d785212', __exports__)
  }
  
  module.hot.accept("./BenefitShowComponent.vue?vue&type=template&id=4d785212", () => {
    api.rerender('4d785212', render)
  })

}


export default __exports__